module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fields":{"headings":{"conditional":"Conditional logic"},"options":{"removeOption":"Remove option"},"conditions":{"addCondition":"Add condition","removeCondition":"Remove condition"}}}}')
  delete Component.options._Ctor
}
